export type CommentsModalInitialView = 'post' | 'comments';
export type CommentsInitialTarget = 'comments' | 'composer' | null;
export interface CommentsInitialPosition {
  target: Exclude<CommentsInitialTarget, null>;
  settled: boolean;
}

interface ResolveCommentsInitialTargetOptions {
  initialView: CommentsModalInitialView;
  loading: boolean;
  hasMedia: boolean;
  mediaReady: boolean;
  hasComments: boolean;
  loadError: boolean;
  canCompose: boolean;
}

export const resolveCommentsInitialTarget = ({
  initialView,
  loading,
  hasMedia,
  mediaReady,
  hasComments,
  loadError,
  canCompose,
}: ResolveCommentsInitialTargetOptions): CommentsInitialTarget => {
  if (
    initialView !== 'comments'
    || loading
    || (hasMedia && !mediaReady)
  ) {
    return null;
  }

  if (!hasComments && !loadError && canCompose) {
    return 'composer';
  }

  return 'comments';
};

/**
 * Gives comment-intent modals an immediate provisional destination while
 * comments or media are still loading. The final position is applied again
 * once layout is stable, which prevents the post top from flashing first.
 */
export const resolveCommentsInitialPosition = (
  options: ResolveCommentsInitialTargetOptions,
): CommentsInitialPosition | null => {
  const finalTarget = resolveCommentsInitialTarget(options);
  if (finalTarget) return { target: finalTarget, settled: true };
  if (options.initialView !== 'comments') return null;
  return { target: 'comments', settled: false };
};
